import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import { getDocDataById } from "../../models/DataFunctions.js";

/**
 * Create a task via the dedicated /tasks/create endpoint.
 * The backend handles notifications to assigned users.
 *
 * @param {object} data - Task data (master_id, users_id, title, content, folder_ref, extra).
 * @param {string} prefix - API endpoint prefix.
 * @returns {Promise<object|string>} - Returns the created task document or empty string on failure.
 */
const createTaskApi = async (data, prefix) => {
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}tasks/create`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    if (response.ok) {
      const responseData = await response.json();
      if (responseData.id) {
        let doc = await getDocDataById("task", responseData.id);
        return doc;
      }
    } else {
      console.error(`Failed to create task: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default createTaskApi;
